module.exports = __webpack_public_path__ + "static/img/bank.b3f99d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank.png
// module id = P54z
// module chunks = 0